import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/report";

export default class ReportsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getList = (type, params) => {
		return http.get(`${apiEndpoint}/${type}`, { params });
	};
}
